const radio = "radio";
const checkbox = "checkbox";
const slider = "slider";
const weight = "weight";
const height = "height";
const combinedHeight = "combinedHeight";
const productCheckbox = "product_checkbox";
const questionTypes = {
    radio,
    checkbox,
    slider,
    weight,
    height,
    combinedHeight,
    productCheckbox
};
export default questionTypes;
